import { render, staticRenderFns } from "./AddRappels.vue?vue&type=template&id=08157038&scoped=true&lang=true"
import script from "./AddRappels.vue?vue&type=script&lang=js"
export * from "./AddRappels.vue?vue&type=script&lang=js"
import style0 from "./AddRappels.vue?vue&type=style&index=0&id=08157038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08157038",
  null
  
)

export default component.exports